// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_ja-5";
export var filledCircle = "_ja-4";
export var historyEntry = "_ja-3";
export var messageSideLeft = "_ja-1";
export var messageSideRight = "_ja-2";
export var orderTrackingInfoContainer = "_ja-0";